import { render, staticRenderFns } from "./classPage.vue?vue&type=template&id=a88e32b4&"
import script from "./classPage.vue?vue&type=script&lang=js&"
export * from "./classPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports